'use client';

import React from "react";
import PageWrapper from "@/components/layouts/PageWrapper/PageWrapper";
import ChatList from "@/components/chats/List";
import ChatRoom from "@/components/chats/Room";

const ChatsClient = () => {
  return (
    <>
      <ChatList />
      <PageWrapper className='pl-[25rem]'>
        <div></div>
      </PageWrapper>
    </>
  )
}

export default ChatsClient;